import {ChangeDetectionStrategy, Input} from '@angular/core';

export abstract class ScoreboardComponent {
	@Input() gameSummary:any;

	constructor() {
	}

}
